// this is an autogenerated file from App/Account/Content/Settings/Content/CalendarSettings/LocationChooser/Location/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_CalendarSettings_LocationChooser_Location{
  session_user_locations(order_by: { name: asc }) {
    _id
    text: name
  }
}

`